export const ROOT_CATEGORIES_REQUEST_SUCCESS = 'ROOT_CATEGORIES_REQUEST_SUCCESS';
export const ROOT_CATEGORIES_REQUEST_LOADING = 'ROOT_CATEGORIES_REQUEST_LOADING';
export const ROOT_CATEGORIES_REQUEST_FAILED = 'ROOT_CATEGORIES_REQUEST_FAILED';